import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { PhoneService } from '../services';
import { PhoneList, Variant } from '../models';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
  private sub;
  highlights: Variant[];

  constructor(private phoneService: PhoneService, private router: Router) { }

  ngOnInit() {
    this.sub = this.phoneService.obs.phoneList
      .subscribe((phoneList: PhoneList) => {
        this.highlights = <Array<Variant>>Array.from(phoneList.highlights.values());
        // console.log(this.highlights);
      });
  }

  onSearch({brand, phone, variant}) {
    console.log(brand, phone, variant);
    const brandId = brand.id;
    const phoneId = phone.id;
    const variantNameId = variant.nameId;
    let url = `quotazione-cellulare/${brandId}`;
      if (!brandId) {
        return false;
      }
      if (phoneId) {
        url += `/${phoneId}`;
      }
      if (variantNameId) {
        url += `/${variantNameId}`;
      }
      console.log(url);
      this.router.navigateByUrl(url);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/home-page/home-page.component.ts